import { useState, useEffect } from 'react';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';



const useFontLoader = (fontMap) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    const loadFonts = async () => {
      try {
        //console.log('1. Preventing splash screen autohide...');
        await Font.loadAsync(fontMap);
        //console.log('2. Loading fonts...');
        setFontLoaded(true);
        //console.log('3. Fonts loaded successfully!');
      } catch (error) {
        //console.error('Error loading fonts:', error);
      }
    };

    loadFonts();
  }, [fontMap]);
  return fontLoaded


  // useEffect(() => {
  //   async function loadFonts() {
  //     try {
  //       //console.log('1. Preventing splash screen autohide...');

  //       await SplashScreen.preventAutoHideAsync();
  //       //console.log('2. Loading fonts...');

  //       await Font.loadAsync(fontMap);
  //       //console.log('3. Fonts loaded successfully!');

  //     } catch (e) {
  //       console.warn('Error loading fonts:', e);
  //     } finally {
  //       //console.log('4. Font loading process finished. Hiding splash screen...');

  //       // Set the state to true, which will trigger the app's rendering
  //       setFontLoaded(true);
  //       // This is the crucial step: tell the splash screen to hide
  //       //console.log('5. about to hide.');
  //       await SplashScreen.hideAsync();
  //       //console.log('6. Splash screen hidden.');

  //     }
  //   }
  //   loadFonts();
  // }, [fontMap]);
  // return fontLoaded;
};

export default useFontLoader;
